import { Trans, useTranslation } from "react-i18next";
import AppContainer from "../../../components/app-container/AppContainer";

import React, { useEffect } from "react";
import "./InstructionsPage.scss";
import { Etracker } from "spot-component-library/lib/components/etracker/Etracker";
import { readLanguageFromCookie } from "../../../components/GeneralUtils";
import tenantService from "../../../services/TenantService";

interface Question {
    HEADLINE: string;
    CONTENT: string;
    LINK?: string;
    IMAGE_URL?: string;
    IMAGE?: boolean;
    IMAGE_ALT_TAG?: string;
}

const InstructionsPage: React.FC = () => {
    const { t } = useTranslation();
    const [tenant, setTenant] = React.useState<string>("");
    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        const tenant = await tenantService.getTenant();
        setTenant(tenant);
    };

    // Use type assertion to indicate that the result is an array of Question
    const questions = t("INSTRUCTION_PAGE.QUESTIONS", { returnObjects: true }) as Question[];

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <Etracker pageName={"InstructionPage"} popto={"1500"} tenant={tenant.toString()} language={readLanguageFromCookie()} />
                <div className={"instruction-page"}>
                    <h1 role="heading">{t("INSTRUCTION_PAGE.HEADLINE")}</h1>
                    {questions.map((question, index) => (
                        <section key={index}>
                            <h3>{question.HEADLINE}</h3>
                            {question.IMAGE && <img src={question.IMAGE_URL} alt={question.IMAGE_ALT_TAG} />}
                            {/* Use Trans component to render HTML content */}
                            <Trans i18nKey={`INSTRUCTION_PAGE.QUESTIONS.${index}.CONTENT`} components={{ a: <a /> }}>
                                {/* Fallback content in case translation is missing */}
                                {question.CONTENT}
                            </Trans>
                        </section>
                    ))}
                </div>
            </AppContainer>
        </>
    );
};

export default InstructionsPage;
